import { AnimatePresence, domAnimation, LazyMotion, motion } from "framer-motion";
import { useRef, CSSProperties } from "react";
import styles from "./skeleton-styles.module.scss";
import { SkeletonLoaderOptions } from "./skeleton-loader-options";
import { randomString } from "@/utils/utils";

export default function SkeletonRect(props: SkeletonLoaderOptions) {
	const key = useRef(randomString(7));

	return (
		<LazyMotion features={domAnimation}>
			{props.loading && (
				<motion.div
					className={'loading-overlay'}
					style={props.justify ? { alignItems: props.justify } : {}}
					exit={{ opacity: 0 }}
					key={`loader-${key.current}`}
				>
					<motion.div className={styles.skeletonLoaderContainer}>
						<svg
							style={
								{
									...props,
									'--background-color': props.backgroundColor ?? 'var(--backgroundColor)',
									'--rate': props.rate,
								} as CSSProperties
							}
							className={`${styles.skeletonLoader}`}
						>
							<rect
								height={props.height ?? '100%'}
								width={props.width ?? '100%'}
								className={styles.skeletonLoaderRect}
								rx={props.radius ?? '8px'}
							/>
						</svg>
					</motion.div>
				</motion.div>
			)}
		</LazyMotion>
	);
}
